import { DocumentReference } from '@marmon/shared/types/common';
import { Organization } from '../interfaces';

export class OrganizationItem {
	name!: string;
	id!: string;
	ref!: DocumentReference<Organization>;

	constructor(
		organization: Organization,
		ref: DocumentReference<Organization>,
	) {
		this.name = organization.name;
		this.id = organization.id;
		this.ref = ref;
	}

	toString(): string {
		return this.name;
	}

	valueOf(): DocumentReference<Organization> {
		return this.ref;
	}
}
